import React from "react"
import { Box, Modal } from "@mui/material"
import { ARIA_LABELS } from "@/shared/components/image-gallery/constants"

interface GalleryModalShellProps {
  onClose: () => void
  children: React.ReactNode
}

const GalleryModalShell: React.FC<GalleryModalShellProps> = ({ onClose, children }) => {
  return (
    <Modal open onClose={onClose} disableAutoFocus aria-label={ARIA_LABELS.modal}>
      <Box
        sx={{
          position: "fixed",
          inset: 0,
          bgcolor: "rgba(180,180,180,0.95)",
          display: "flex",
          alignItems: "stretch",
          outline: "none"
        }}>
        {children}
      </Box>
    </Modal>
  )
}

export default GalleryModalShell
